import {stepsArray} from './dummyData.js';
import webservice from '../../API/webservice.js';

const initialState = {
    isLoading       : false,
    quizActive      : false, //false
    quizSettings    : null,
    useDummyData    : true,
    previousQuestion    : 0,
    goToRev         : false,
    formSelfValidate: false,
    currentStep: 0,
    mapsAPIloaded: false
};

export default function quizReducer(state = initialState, action) {

    switch (action.type) {
                
        case 'SET_QUIZ_DATA':        
            return Object.assign({}, state, {quizSettings: action.data})
        
        case 'SET_PREVIOUS_QUESTION':
            return Object.assign({}, state, {previousQuestion: action.data})

        case 'GO_BACK_TO_STEP':
            const myItems = state.quizSettings.Items.slice(0,action.step+1);
            const myNewQS = Object.assign({}, state.quizSettings) 
            myNewQS.Items = myItems
            myNewQS.CurrentItem = action.step+1
            return Object.assign({}, state, {quizSettings: myNewQS,currentStep: action.step}) 
        
        case 'GO_TO_STEP':
            return Object.assign({}, state, {currentStep: action.step})    

        case 'SET_REV':
            return Object.assign({}, state, {goToRev: action.data})     
        
        case 'SET_MAP_API':
            return Object.assign({}, state, {mapsAPIloaded: action.value})     
        
        case 'RESET_QUIZ_DATA':
            const items = state.quizSettings.Items[0]
            const newQS = Object.assign({}, state.quizSettings) 
            newQS.Items = [items] 
            newQS.CurrentItem = 1
            return Object.assign({}, state, {quizSettings: newQS})

        default:
            return state
    
    }
}


export const setQuizData = (data) => ({
    type: 'SET_QUIZ_DATA', data
})

export const setRev = (data) => ({
    type: 'SET_REV', data
})

export const setMapsAPI = (value) => ({
    type: 'SET_MAP_API', value
})

export const setPreviousQuestion = (data) => ({
    type: 'SET_PREVIOUS_QUESTION', data
})

export const resetQuizData = () => ({
    type: 'RESET_QUIZ_DATA'
})

export const goBackToStep = (step) => ({
    type: 'GO_BACK_TO_STEP', step
})

export const goToStep = (step) => ({
    type: 'GO_TO_STEP', step
})

export const submitDataToServer = (data) => ({
    type: 'SUBMIT_DATA_TO_SERVER', data
})

export const quizSelector = {
    quizSettings    : (state) => state.quiz.quizSettings,
    previousQuestion: (state) => state.quiz.previousQuestion,
    useDummyData    : (state) => state.quiz.useDummyData,
    goToRev         : (state) => state.quiz.goToRev,
    getCurrentStep  : (state) => state.quiz.currentStep,
    mapsAPIloaded    : (state) => state.quiz.mapsAPIloaded,
};